/* DependencyFlow — Overview mini dependency summary: the build chain
 * sources → workflows → journeys as linked counts. One glance answers
 * "what feeds what, and is anything empty?". */
import React from 'react';
import {
    useNavigate
} from 'react-router-dom';
import {
    ArrowRight,
    Map as MapIcon,
    Plug,
    Workflow as WorkflowIcon
} from 'lucide-react';
import {
    useAppStudio
} from '../../AppStudioContext';
import './visuals.css';

export default function DependencyFlow({
    sources,
    workflows,
    journeys
}: {
    sources: number | null;
    workflows: number | null;
    journeys: number | null;
}) {
    const nav = useNavigate();
    const {
        confirmLeave
    } = useAppStudio();
    const go = (seg: string) => {
        if (!confirmLeave()) return;
        nav(`../${seg}`);
    };
    const items = [
        {
            seg: 'sources',
            label: 'Sources',
            icon: Plug,
            n: sources
        },
        {
            seg: 'workflows',
            label: 'Workflows',
            icon: WorkflowIcon,
            n: workflows
        },
        {
            seg: 'journeys',
            label: 'Journeys',
            icon: MapIcon,
            n: journeys
        }
    ];
    return (
        <div className="aps-depflow">
            {items.map((it, i) => {
                const Icon = it.icon;
                return (
                    <React.Fragment key={it.seg}>
                        {i > 0 && <ArrowRight size={15} className="aps-depflow-arrow" />}
                        <button
                            className="aps-depflow-link"
                            title={`Open ${it.label}`}
                            onClick={() => go(it.seg)}
                        >
                            <Icon size={14} />
                            {it.label}
                            <span className="aps-depflow-num">{it.n == null ? '—' : it.n}</span>
                        </button>
                    </React.Fragment>
                );
            })}
            <span className="aps-depflow-note">
                capabilities power workflows; workflows power journey surfaces
            </span>
        </div>
    );
}
